export const VAPORLIGHT_BUTTON_SIZES = {
  "&.MuiButton-root.MuiButton-sizeSmall": {
    height: 32,
    minHeight: 32,
    minWidth: 59
  },
  "&.MuiButton-root.MuiButton-sizeMedium": {
    height: 40,
    minHeight: 40,
    minWidth: 64,
    fontSize: 16
  },
  "&.MuiButton-root.MuiButton-sizeLarge": {
    height: 48,
    minHeight: 48,
    minWidth: 64,
    fontSize: 16
  },
  "&.MuiButtonBase-root": {
    paddingLeft: 12,
    paddingRight: 12
  }
};
